export enum EventLocationType {
    Unknown = 0,
    Physical = 1,
    Virtual = 2,
    SingleStore = 3
}